import React, { useContext } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ThemeContext } from '../../../context/ThemeContext';

const menuItems = [
    { name: 'Home', path: '/' },
    { name: 'Projects', path: '/projects' },
    { name: 'Certificates', path: '/certificates' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' }
];

const isRouteActive = (path, pathname) => (
    path === '/' ? pathname === '/' : pathname === path || pathname.startsWith(`${path}/`)
);

const PageLinks = () => {
    const { theme, themes } = useContext(ThemeContext);
    const location = useLocation();

    return (
        <ul className="flex items-center space-x-6 list-none m-0 p-0">
            {menuItems.map((item) => {
                const isActive = isRouteActive(item.path, location.pathname);
                return (
                    <motion.li
                        key={item.name}
                        whileHover={{ scale: 1.08, y: -1 }}
                        whileTap={{ scale: 0.95 }}
                        transition={{ type: 'spring', stiffness: 400, damping: 25 }}
                        className="relative flex flex-col items-center"
                    >
                        <NavLink
                            to={item.path}
                            className={`text-md font-medium tracking-wide no-underline transition-colors duration-150 focus:outline-none focus:ring-0 ${
                                isActive
                                    ? `${themes[theme].text} opacity-100 font-semibold`
                                    : `${themes[theme].text} opacity-60 hover:opacity-100`
                            }`}
                        >
                            {item.name}
                        </NavLink>

                        {/* Subtle Active Route Dot */}
                        {isActive && (
                            <motion.span
                                layoutId="activeNavDot"
                                className="absolute -bottom-2 w-1 h-1 rounded-full bg-emerald-400 shadow-[0_0_6px_rgba(52,211,153,0.8)]"
                                transition={{ type: 'spring', stiffness: 380, damping: 28 }}
                            />
                        )}
                    </motion.li>
                );
            })}
        </ul>
    );
};

export default PageLinks;
